import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Alert } from 'react-bootstrap'

/**
 * Modal para solicitar firma remota del cliente
 * Permite ingresar/editar el email antes de enviar la solicitud
 */
const ModalFirmaRemota = ({ show, onHide, equipos, ots, onSolicitar, loading }) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  
  // Sincronizar email cuando cambian los datos de la OT
  useEffect(() => {
    if (show && ots?.cliente?.correo) {
      setEmail(ots.cliente.correo)
    }
  }, [show, ots])
  
  const handleSubmit = () => {
    // Validación básica de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email || !emailRegex.test(email)) {
      setError('Por favor ingrese un email válido')
      return
    }
    
    setError('')
    onSolicitar(email)
  }
  
  const handleClose = () => {
    setError('')
    onHide()
  }
  
  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-envelope-paper me-2"/>
          Solicitar Firma Remota del Cliente
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" dismissible onClose={() => setError('')}>
            {error}
          </Alert>
        )}
        
        <div className="mb-3">
          <p className="text-muted">
            Se enviará un correo electrónico al cliente con un enlace para firmar la confirmación del servicio.
            El enlace será válido por <strong>7 días</strong>.
          </p>
        </div>
        
        <div className="mb-3">
          <div className="bg-light p-3 rounded border">
            <div className="small mb-2"><strong>Resumen:</strong></div>
            <div className="small">
              <div><strong>Orden de Trabajo:</strong> {ots?.numeroOrden}-{ots?.visitas}</div>
              <div><strong>Cliente:</strong> {ots?.cliente?.nombre}</div>
              <div><strong>Equipos a incluir:</strong> {equipos?.length || 0}</div>
            </div>
          </div>
        </div>
        
        <Form.Group>
          <Form.Label className="fw-bold">
            Correo Electrónico del Cliente <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="email"
            placeholder="ejemplo@correo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            autoFocus
          />
          <Form.Text className="text-muted">
            El cliente recibirá un enlace seguro para firmar digitalmente
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Enviando...
            </>
          ) : (
            <>
              <i className="bi bi-send me-2"/>
              Enviar Solicitud
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalFirmaRemota
